var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.898 10.336 8.11 3.81C6.78 2.924 5 3.877 5 5.474v13.052c0 1.597 1.78 2.55 3.11 1.664l9.788-6.526a2 2 0 0 0 0-3.328Zm-8.68-8.19C6.562.374 3 2.279 3 5.474v13.052c0 3.195 3.56 5.1 6.219 3.328l9.789-6.526c2.375-1.583 2.375-5.073 0-6.656l-9.79-6.526Z",
    fill: "#777E91"
  })));
};
export default SvgLine;